import React from 'react'
import logo from '../assets/img/logo.svg'

const HeaderLogo = ({ siteTitle }) => (
  <img src={logo} className="header-logo" alt={siteTitle} />
)

export default HeaderLogo


// WEBPACK FOOTER //
// ./src/components/HeaderLogo.js